import React from "react";

/**
 * Product card shown before we fetch actual data.
 */
const ProductCardLoading = () => {
  return (
    <div className="p-2 md:p-4">
      <div className="skeleton h-52 w-full" />
      <div className="flex flex-col space-y-4 py-4">
        <span className="skeleton flex-1 opacity-70">...</span>
        <span className="skeleton flex-1 opacity-50">...</span>
        <span className="skeleton flex-1 opacity-30">...</span>
      </div>
    </div>
  );
};

export default ProductCardLoading;
